'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _viewports = require('./viewports');

var _viewports2 = _interopRequireDefault(_viewports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewportManager = function (_Component) {
    _inherits(ViewportManager, _Component);

    function ViewportManager() {
        _classCallCheck(this, ViewportManager);

        var _this = _possibleConstructorReturn(this, (ViewportManager.__proto__ || Object.getPrototypeOf(ViewportManager)).apply(this, arguments));

        _this.state = { viewport: null };
        _this.updateViewport = function () {
            var windowWidth = window.innerWidth;
            var currentViewport = _this.state.viewport;
            var _this$props = _this.props,
                viewports = _this$props.viewports,
                onViewportChange = _this$props.onViewportChange,
                onWindowWidthChange = _this$props.onWindowWidthChange,
                logInfo = _this$props.logInfo;

            var deviceViewport = Object.entries(viewports).reverse().find(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    name = _ref2[0],
                    width = _ref2[1];

                return windowWidth >= width;
            }); // eslint-disable-line no-unused-vars
            var newState = {
                viewport: deviceViewport[0],
                viewportWidth: deviceViewport[1],
                windowWidth: windowWidth
            };
            if (onViewportChange && currentViewport !== newState.viewport) {
                onViewportChange(newState);
            }
            if (onWindowWidthChange) {
                onWindowWidthChange(newState);
            }
            if (logInfo) {
                console.groupCollapsed('viewport info');
                console.log('viewport name: ' + newState.viewport);
                console.log('viewport min width: ' + newState.viewportWidth);
                console.log('window width: ' + newState.windowWidth);
                console.groupEnd();
            }
            _this.setState(newState);
        };
        _this.render = function () {
            return null;
        };
        return _this;
    }

    _createClass(ViewportManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.updateViewport();
            window.addEventListener('resize', this.updateViewport, false);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.updateViewport);
        }
    }]);

    return ViewportManager;
}(_react.Component);

exports.default = ViewportManager;

ViewportManager.propTypes = {
    viewports: _propTypes2.default.shape({
        xsmall: _propTypes2.default.number,
        small: _propTypes2.default.number,
        medium: _propTypes2.default.number,
        large: _propTypes2.default.number,
        xlarge: _propTypes2.default.number
    }),
    onViewportChange: _propTypes2.default.func.isRequired,
    onWindowWidthChange: _propTypes2.default.func.isRequired,
    logInfo: _propTypes2.default.bool.isRequired
};
ViewportManager.defaultProps = {
    viewports: Object.freeze(_viewports2.default)
};
//# sourceMappingURL=ViewportManager.js.map